"use strict";

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/inherits");

var _wrapNativeSuper = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var _defineProperty = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/defineProperty");

var _exports$ErrorMessage;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var types_1 = require("./types");

exports.ErrorMessagesPerCode = (_exports$ErrorMessage = {}, _defineProperty(_exports$ErrorMessage, types_1.ErrorCode.IncompatibleBrowser, 'The browser being used is not compatible with Ethereum'), _defineProperty(_exports$ErrorMessage, types_1.ErrorCode.WalletIsLocked, 'The wallet is locked, if Metamask extension is being used, the user needs to unlock it first'), _defineProperty(_exports$ErrorMessage, types_1.ErrorCode.UserDeniedAccess, 'The user denied access'), _defineProperty(_exports$ErrorMessage, types_1.ErrorCode.TransactionRejectedByUser, 'The user rejected the transaction'), _defineProperty(_exports$ErrorMessage, types_1.ErrorCode.UnexpectedReturnData, 'The data returned by the smart contract has an unexpected format. Please report this issue to the Polymath team'), _defineProperty(_exports$ErrorMessage, types_1.ErrorCode.InvalidAddress, 'Invalid Address'), _defineProperty(_exports$ErrorMessage, types_1.ErrorCode.NonBrowserEnvironment, 'Attempted to call a browser utility in a non-browser environment'), _defineProperty(_exports$ErrorMessage, types_1.ErrorCode.MetamaskNotInstalled, 'You must install the Metamask browser extension if attempting to use Polymath SDK from the browser'), _exports$ErrorMessage);
/**
 * Wraps an error to give more information about it's type
 */

var PolymathError =
/*#__PURE__*/
function (_Error) {
  _inherits(PolymathError, _Error);

  // eslint-disable-next-line require-jsdoc
  function PolymathError(_ref) {
    var _this;

    var message = _ref.message,
        code = _ref.code;

    _classCallCheck(this, PolymathError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PolymathError).call(this, message || exports.ErrorMessagesPerCode[code] || "Unknown error, code: ".concat(code))); // eslint:disable-next-line
    // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
    // Object.setPrototypeOf(this, PolymathError);

    _this.code = code;
    return _this;
  }

  return PolymathError;
}(_wrapNativeSuper(Error));

exports.PolymathError = PolymathError;